import { useState, type HTMLAttributes } from 'react';
import { usePhone } from '@/lib/responsive';
import { ResponsiveOverlay } from './responsive-overlay';

/** The editor owns section and draft state, so changing this navigation cannot reset either. */
export function ResponsiveRail({ children, className, ...props }: HTMLAttributes<HTMLElement>) {
  const phone = usePhone();
  const [open, setOpen] = useState(false);
  if (!phone)
    return (
      <aside {...props} className={className}>
        {children}
      </aside>
    );
  return (
    <div className="config-mobile-navigation">
      <button
        className="btn"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        Configuration sections <span aria-hidden="true">⌄</span>
      </button>
      {open && (
        <ResponsiveOverlay
          label="Configuration sections"
          kind="picker"
          className="filter-sheet"
          onClose={() => setOpen(false)}
        >
          <div className="drawer-hd">
            <h2>Configuration sections</h2>
            <button className="btn" onClick={() => setOpen(false)}>
              Done
            </button>
          </div>
          <aside
            {...props}
            className={`${className} config-mobile-rail`}
            onClick={(event) => {
              if ((event.target as HTMLElement).closest('.admin-config-section')) setOpen(false);
            }}
          >
            {children}
          </aside>
        </ResponsiveOverlay>
      )}
    </div>
  );
}
